<script lang="ts">
	import { buildImageUrl, type ImageDimensions } from './api/sanityWebsiteClient';

	type ImageVariant = ImageDimensions & { assetId?: string };

	interface Props {
		assetId: string;
		alt?: string;
		title?: string;
		loading?: HTMLImageElement['loading'];
		dimensions?: ImageDimensions;
		width?: string | undefined;
		height?: string | undefined;
		variants?: Record<number | string, ImageVariant>;
		wrapperClass?: string;
		class?: string;
		style?: string;
	}

	let {
		assetId,
		alt = '',
		title = '',
		loading = 'lazy',
		dimensions = {},
		width,
		height,
		variants = {},
		wrapperClass,
		class: className,
		style
	}: Props = $props();

	let sortedVariants = $derived(
		Object.keys(variants).sort((a, b) => {
			if (isNaN(Number(a)) && isNaN(Number(b))) {
				// If both are strings, sort alphabetically
				return a.localeCompare(b);
			} else if (isNaN(Number(a))) {
				// If 'a' is a string and 'b' is a number, 'a' comes first
				return -1;
			} else if (isNaN(Number(b))) {
				// If 'a' is a number and 'b' is a string, 'b' comes first
				return 1;
			} else {
				// If both are numbers, sort in descending order
				return Number(b) - Number(a);
			}
		})
	);
</script>

<picture class={wrapperClass}>
	{#each sortedVariants as queryOrWidth}
		{@const { assetId: variantAssetId, ...dimensions } = variants[queryOrWidth]}

		<source
			media={queryOrWidth.startsWith('(') ? queryOrWidth : `(min-width: ${queryOrWidth}px)`}
			srcset={buildImageUrl(variantAssetId || assetId, dimensions)}
		/>
	{/each}
	<img
		src={buildImageUrl(assetId, dimensions)}
		{alt}
		{title}
		{loading}
		{height}
		{width}
		class={className}
		{style}
	/>
</picture>
